var map = {
	"./IMG9.jpg": 3368,
	"./IMG_932.jpg": 2330,
	"./IMG_96.jpg": 9227,
	"./IMG_961.jpg": 6518,
	"./IMG_975.jpg": 4109,
	"./web.whatsapp.jpeg": 7849,
	"./z1.jpg": 9357,
	"./z2.jpg": 9458,
	"./z23.jpg": 703,
	"./z4.jpg": 9428,
	"./z44.jpg": 114,
	"./z5.jpg": 7473,
	"./z56.jpg": 1619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5065;